import React from 'react';
import { Form, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';

interface BusinessDomain {
  label: string;
  value: string;
}

interface StepActivityProps {
  businessDomain: string;
  activityDescription: string;
  onBusinessDomainChange: (value: string) => void;
  onActivityDescriptionChange: (value: string) => void;
  stepTitle: string;
  businessDomains: BusinessDomain[];
}

const StepActivity: React.FC<StepActivityProps> = ({
  businessDomain,
  activityDescription,
  onBusinessDomainChange,
  onActivityDescriptionChange,
  stepTitle,
  businessDomains,
}) => {
  return (
    <div className="signup__step-content">
      <h2 className="signup__step-title">{stepTitle}</h2>
      <p className="signup__step-subtitle">Domaine d'activité</p>

      <Form.Item label="Domaine d'activité" layout="vertical">
        <Select
          style={{ width: '100%' }}
          options={businessDomains}
          value={businessDomain}
          onChange={(value) => onBusinessDomainChange(value)}
        />
      </Form.Item>

      <Form.Item label="Parlez-moi de votre activité (optionnel)" layout="vertical">
        <TextArea
          value={activityDescription}
          onChange={(e) => onActivityDescriptionChange(e.target.value)}
          placeholder="Décrivez l'activité, les services, la clientèle..."
          rows={4}
        />
      </Form.Item>
    </div>
  );
};

export default StepActivity;
